(ns frontend.ux-overhaul.page-components.page-layout
  (:require
   [frontend.ux-overhaul.page-components.navigation.navbar :as navbar]
   [ui.util :as uu]))

(defn new-navigation-layout
  [{:keys [class-name metabase?]} child-view]
  [:div
   {:class
    (uu/cm
     "h-full w-full flex-1 flex flex-col relative"
     (when class-name
       class-name))}
   [navbar/view]
   [:div
    {:class (uu/cm "flex-1 flex w-full max-w-full overflow-y-auto"
                   (when metabase?
                     "overflow-auto"))}

    [:div {:class "h-full w-full flex-1 flex flex-col
                 text-base-light-text
                 bg-base-light relative"}
     child-view]]])
